<template>
  <div>  
    <div
        class="step__value step__value--margin-bottom"
        v-for="(value, key) in guestList"
        :key="key"
      >                      
        <div class="value" v-if="Object.keys(guestList).length > 1">
          {{ getFormattedDate(key.split('|')[0]) }} to {{ getFormattedDate(key.split('|')[1]) }}
          <iconCampingCard v-if="key.split('|')[2] === 'choice'" class="cca-icon"></iconCampingCard>
        </div>                     
        <div>
          <div
            class="wrapper d-flex justify-content-between"
            :class="{ 'no-padding': isCompleted }"
            v-for="(person, index) in value"
            :key="index"
          >
            <span>{{ person.amount }}x {{ person.name }}</span>
            <div class="prices">
              <span
                class="price__value label"
                v-if="!person.included"
                >{{
                  person.price
                    | currency(campground.currency, language.code)
                }}</span
              >
              <span
                class="price__value label"
                v-if="person.included"
                >{{ $t('generic.labels.included') }}</span
              >
            </div>
          </div>
        </div>
      </div>  
  </div>
</template>

<script>
import bookingDataMixin from '@/mixins/bookingDataMixin'
import { mapGetters } from 'vuex';
import iconCampingCard from '@/assets/icons/camping-card.svg'

export default {
  name: "CiGuestList",
  components: {
    iconCampingCard,
  },
  mixins: [bookingDataMixin],
  props: {
    guestList: {
      type: Object,
      required: true,
    },
    currency: {
      type: Object,
      required: true,
    },
    language: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('booking', {
      dates: 'dates',
      isCompleted: 'isCompleted',
    }),
    ...mapGetters('campground', {
      countries: 'countries',
      campground: 'campground',
    }),
  },
};
</script>

<style lang="scss">
@import '../../assets//styles/summary-step';
</style>